// Source timing and media size guardrails. Never change frame rate for a proxy.
export const PROXY_VIDEO_BITRATE=700_000; // 480p interview video
export const PROXY_AUDIO_BITRATE=256_000; // High-quality AAC only when copy impossible
export const PROXY_MAX_SOURCE_BYTES=60_000_000_000; // Local-only camera original; never uploaded
export function estimateProxyBytes(duration,videoBps=PROXY_VIDEO_BITRATE,audioBps=PROXY_AUDIO_BITRATE){
 if(!Number.isFinite(duration)||duration<=0)return Infinity;
 return Math.ceil(duration*(videoBps+audioBps)/8*1.18+2_000_000);
}
export function shouldOfferProxy(file,metadata,maxUploadBytes){
 return Boolean(file?.size>maxUploadBytes ||
  (file?.size>12_000_000 && (metadata?.height>480 || metadata?.width>900)));
}
export function validateProxyTiming(source,proxy,{duration,proxyDuration,sourceAudioStart,proxyAudioStart,sourceVideoStart,proxyVideoStart}={}){
 if(source?.frameStatus!=='detected-cfr'||proxy?.frameStatus!=='detected-cfr')
  throw new Error('Frame rate could not be verified. Export a 480p proxy with the original frame rate in Premiere or Media Encoder.');
 if(source.fpsNum!==proxy.fpsNum||source.fpsDen!==proxy.fpsDen)
  throw new Error('Proxy frame rate differs from the camera original. Nothing was uploaded.');
 if(!Number.isSafeInteger(source.frameCount)||proxy.frameCount!==source.frameCount)
  throw new Error('The proxy lost or added video frames. Nothing was uploaded.');
 const frameSeconds=source.fpsDen/source.fpsNum;
 if(!Number.isFinite(duration)||!Number.isFinite(proxyDuration)||Math.abs(duration-proxyDuration)>Math.min(0.05,frameSeconds))
  throw new Error('Proxy duration changed beyond a safe frame-timing tolerance. Nothing was uploaded.');
 if(![sourceAudioStart,proxyAudioStart,sourceVideoStart,proxyVideoStart].every(Number.isFinite))
  throw new Error('Cannot verify the source and proxy audio/video starts. Nothing was uploaded.');
 // Do not silently shift video frames. AAC priming can legitimately differ by
 // ~one audio frame when a non-AAC source must be encoded.
 if(Math.abs(sourceVideoStart-proxyVideoStart)>0.005)
  throw new Error('Proxy video timestamp origin changed. Nothing was uploaded.');
 if(Math.abs(sourceAudioStart-proxyAudioStart)>0.046)
  throw new Error('Proxy audio start shifted. Nothing was uploaded.');
 return true;
}
